import { useTranslation } from "react-i18next";
import { changeLang } from "@/lib/i18n";

export default function LanguageToggle({ compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith("es") ? "es" : "en";
  const swap = () => changeLang(current === "en" ? "es" : "en");
  return (
    <button
      data-testid="lang-toggle"
      onClick={swap}
      className={`inline-flex min-h-[44px] items-center gap-2 rounded-full border border-slate-700 bg-slate-800/70 px-3 py-2 text-xs font-semibold uppercase tracking-wider text-slate-100 transition-colors hover:bg-slate-700 hover:text-white active:scale-95 ${compact ? "" : ""}`}
      aria-label="Toggle language"
    >
      <span className={current === "en" ? "text-brand" : "text-slate-400"}>EN</span>
      <span className="text-slate-500">/</span>
      <span className={current === "es" ? "text-brand" : "text-slate-400"}>ES</span>
    </button>
  );
}
